import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const ArrowCycle: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.53264 5.521V6.94541C7.53264 7.01866 7.57121 7.08137 7.63649 7.11446C7.7018 7.14755 7.77519 7.14152 7.83419 7.09819L12.0755 3.9865C12.1241 3.95089 12.1509 3.89994 12.1528 3.83975C12.1548 3.7796 12.1313 3.72699 12.0851 3.68838L7.84371 0.13854C7.78594 0.0902252 7.71013 0.0803024 7.6419 0.112164C7.57367 0.144025 7.53261 0.208505 7.53261 0.283846V1.60708C0.919969 1.60708 -1.24887 6.46858 0.672295 9.92583C1.73505 5.78755 5.20507 5.521 7.53264 5.521ZM6.4674 11.4494C8.79497 11.4494 12.265 11.1828 13.3277 7.04453C15.2489 10.5018 13.08 15.3633 6.4674 15.3633V16.6865C6.4674 16.7619 6.42637 16.8263 6.3581 16.8582C6.28984 16.8901 6.21406 16.8802 6.15629 16.8318L1.91492 13.282C1.86877 13.2434 1.84524 13.1908 1.84716 13.1306C1.84911 13.0705 1.87591 13.0195 1.92448 12.9839L6.16585 9.87217C6.22489 9.82884 6.29824 9.82285 6.36355 9.8559C6.42886 9.88899 6.4674 9.9517 6.4674 10.0249V11.4494Z"
        fill="currentColor"
      />
    </svg>
  )
})

ArrowCycle.displayName = 'ArrowCycle'
